import React from 'react';
import DivContainerBody from '../../../../../../../components/DivContainerBody';
import HeadTittle from '../../../../../../../components/HeadTittle';
import ButtonAction from '../../../../../../../components/buttons/ButtonAction';
import { EditIcon } from '../../../../../../../components/buttons/IconButtons';
import DividerWithText from '../../../../../../../components/DividerWithText';
import UpdatePolicyApp from './Functionality/UpdatePolicyApp';
import RuleForm from './SubComponents/RuleForm';
import PolicyDetails from "./SubComponents/PolicyDetails";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 */
const UpdatePayrollPolicy = ({ disabled }) => {
    const {
        t,
        item,
        setItem,
        isGlobal,
        emptyFields,
        isValid,
        isValidCalculationValue,
        isValidCalculationValueText,
        handleUpdate,
        goBack,
        handleChange,
        updateRuleField
    } = UpdatePolicyApp({ disabled });

    return (
        <>
            <HeadTittle onBack={goBack} name={disabled ? 'details' : 'update'}>
                {!disabled &&
                    <ButtonAction
                        id='btn_upp_update'
                        name='update'
                        Icon={EditIcon}
                        className='btn-icon-edit'
                        onClick={handleUpdate}
                    />
                }
            </HeadTittle>
            <DivContainerBody>
                <div className='row mt-5'>
                    <PolicyDetails
                        item={item}
                        setItem={setItem}
                        handleChange={handleChange}
                        emptyFields={emptyFields}
                        disabled={disabled}
                    />
                </div>
                <div className='row mb-60px'>
                    <DividerWithText title={t('rule')} spacing={'my-4'} />
                    <RuleForm
                        rule={item}
                        updateRuleField={updateRuleField}
                        emptyFields={emptyFields}
                        isGlobal={isGlobal}
                        isValid={isValid}
                        isValidCalculationValue={isValidCalculationValue}
                        isValidCalculationValueText={isValidCalculationValueText}
                        disabled={disabled}
                    />
                </div>
            </DivContainerBody>
        </>
    );
};

export default UpdatePayrollPolicy;
